// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingPaymentItemResponse

import { PaymentMethod } from './enums.gen';
import { hydrateWidgetBookingPaymentItemCustomer, type WidgetBookingPaymentItemCustomer, type WidgetBookingPaymentItemCustomerApiResponse } from './widgetBookingPaymentItemCustomer.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type WidgetBookingPaymentItemApiResponse = {
	amount: number;
	refunded: number;
	date: string;
	method: PaymentMethod | null;
	customer: WidgetBookingPaymentItemCustomerApiResponse | null;
};

export type WidgetBookingPaymentItem = {
	amount: number;
	refunded: number;
	date: DateTime;
	method: PaymentMethod | null;
	customer: WidgetBookingPaymentItemCustomer | null;
};

export function hydrateWidgetBookingPaymentItem(data: WidgetBookingPaymentItemApiResponse): WidgetBookingPaymentItem {
	return {
		...data,
		date: DateTimefromISO(data.date)!,
		customer: data.customer ? hydrateWidgetBookingPaymentItemCustomer(data.customer) : null,
	};
}